var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4301 0.484191C11.3587 0.339639 11.2445 0.217216 11.101 0.131409C10.9576 0.0456015 10.7908 0 10.6204 0C10.4501 0 10.2833 0.0456015 10.1398 0.131409C9.99634 0.217216 9.88216 0.339639 9.81079 0.484191L7.25168 5.66752L1.18739 6.34002C1.01819 6.35869 0.858262 6.42228 0.726524 6.52324C0.594786 6.62421 0.496756 6.75833 0.444035 6.90974C0.391314 7.06114 0.38611 7.2235 0.429039 7.37758C0.471967 7.53167 0.561231 7.67104 0.686266 7.77919L5.1714 11.6542L3.98101 17.2542C3.94795 17.4103 3.9634 17.572 4.02555 17.7201C4.08769 17.8683 4.19393 17.9967 4.33169 18.0902C4.46946 18.1838 4.633 18.2385 4.80298 18.2479C4.97296 18.2573 5.14226 18.221 5.29088 18.1434L10.6204 15.355L15.95 18.1434C16.0987 18.2213 16.2682 18.2579 16.4385 18.2485C16.6087 18.2392 16.7725 18.1845 16.9105 18.0908C17.0484 17.9971 17.1547 17.8685 17.2168 17.72C17.2789 17.5716 17.2942 17.4096 17.2607 17.2534L16.0704 11.655L20.5546 7.77919C20.6796 7.67104 20.7689 7.53167 20.8118 7.37758C20.8548 7.2235 20.8495 7.06114 20.7968 6.90974C20.7441 6.75833 20.6461 6.62421 20.5143 6.52324C20.3826 6.42228 20.2227 6.35869 20.0535 6.34002L13.9883 5.66669L11.4301 0.484191Z",
    fill: "#ECEBEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.4ea5cdb4b7b3aa95b09fbcb77c7be285.svg";
export { ForwardRef as ReactComponent };